const Red = ({ children }) => {
  return <span style={{ color: "red" }}>{children}</span>;
};

export default Red;
